<template>
  <div class="location-container" @click="clickLocation(index)">
    <div class="location-text">
      <div class="text-left">
        <div class="text-left-title">{{ item.title }}</div>
        <div class="text-visit">
          {{ $t('Profiles_Locations_LastVisit') }} {{ lastVisitFormat(item) }}
        </div>
      </div>
      <div class="text-right">{{ item.amount }}x</div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  name: 'ProfileLocationsListItem',

  props: {
    item: {
      type: Object,
      required: true
    },

    index: {
      required: true
    }
  },

  methods: {
    lastVisitFormat(item) {
      return moment(item.last_time * 1000).format('YYYY/MM/DD')
    },
    clickLocation(index) {
      this.$emit('select-location', this.item, index)
    }
  }
}
</script>

<style scoped>
.location-container {
  border-bottom: 1px solid #ebeef5;
}

.location-container:hover {
  background: #f8fafc;
  cursor: pointer;
}

.location-text {
  display: flex;
  justify-content: space-between;
  padding: 20px;
}

.text-right {
  font-size: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #7e8596;
  background-color: #ebeef5;
  border-radius: 4px;
  width: 25px;
  height: 20px;
}

.text-left-title {
  color: #4b515f;
  font-weight: 600;
  font-size: 12px;
  line-height: 18px;
}
.text-visit {
  color: #737373;
  font-weight: 600;
  font-size: 11px;
  line-height: 18px;
}
</style>



// WEBPACK FOOTER //
// src/modules/profiles/components/ProfileLocationsListItem.vue